import { render, staticRenderFns } from "./Quality.vue?vue&type=template&id=bfc845d2"
import script from "./Quality.vue?vue&type=script&lang=js"
export * from "./Quality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports